import React, { useState } from "react";
import Navbar from "../../Navbar";
import Sidebar from "../superAdminSidebar";
import Footer from "../../Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CategoryCrud from "./CategoryCrud";
import SubCategoryCrud from "./SubCategoryCrud";
import SubSubCategoryCrud from "./SubSubCategoryCrud";
import ProductCrud from "./ProductCrud";

const SpecificationsCrud = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeComponent, setActiveComponent] = useState("categories");

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex min-h-screen">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className="flex-1 flex flex-col">
        <Navbar toggleSidebar={toggleSidebar} />
        <main className="flex-grow p-6">
          <div className="flex space-x-4 mb-6">
            <button
              className={`px-4 py-2 rounded ${activeComponent === "categories" ? "bg-blue-600 text-white" : "bg-gray-200"}`}
              onClick={() => setActiveComponent("categories")}
            >
              Categories
            </button>
            <button
              className={`px-4 py-2 rounded ${activeComponent === "subcategories" ? "bg-blue-600 text-white" : "bg-gray-200"}`}
              onClick={() => setActiveComponent("subcategories")}
            >
              Sub Categories
            </button>
            <button
              className={`px-4 py-2 rounded ${activeComponent === "subsubcategories" ? "bg-blue-600 text-white" : "bg-gray-200"}`}
              onClick={() => setActiveComponent("subsubcategories")}
            >
              Sub Sub Categories
            </button>
            <button
              className={`px-4 py-2 rounded ${activeComponent === "products" ? "bg-blue-600 text-white" : "bg-gray-200"}`}
              onClick={() => setActiveComponent("products")}
            >
              Products
            </button>
          </div>

          <div>
            {activeComponent === "categories" && <CategoryCrud />}
            {activeComponent === "subcategories" && <SubCategoryCrud />}
            {activeComponent === "subsubcategories" && <SubSubCategoryCrud />}
            {activeComponent === "products" && <ProductCrud />}
          </div>
        </main>
        <ToastContainer />
        <Footer />
      </div>
    </div>
  );
};

export default SpecificationsCrud;
